"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion3toVersion4 = void 0;
const updateVersion3toVersion4 = (configuration) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, configuration), { version: 4 }), configuration.main), { footer: Object.assign(Object.assign({}, configuration.footer), { privacyPolicy: {
                url: "",
                color: "#B2B2B2",
                text: "privacy policy"
            } }) });
};
exports.updateVersion3toVersion4 = updateVersion3toVersion4;
//# sourceMappingURL=v4.js.map